import { create } from 'apisauce';
import constants from '../constants';

var baseURL = constants.baseURL;

const api = create({
  baseURL: baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});

export default api;



// WEBPACK FOOTER //
// ./src/api/api.js